import rapidElearningLocale from './en.json'

const en = {
  rapidElearning: rapidElearningLocale,
}

export default en
